import {Button} from 'platform/components';
import {Box, HStack, VStack} from 'platform/foundation';

import {useCallback} from 'react';

import {mergeAll} from 'ramda';

import i18n from '@dms/i18n';
import {DmsDataGrid, refreshDmsDatagrid} from '@dms/shared';

import {Nullish, TestIdProps, suffixTestId} from 'shared/web';

import type {QueryFilterObject} from 'features/eag-grid';

interface AvailabilityTabProps extends TestIdProps {
  manufacturerNumber: string | Nullish;
  manufacturerId: string | Nullish;
}

export function AvailabilityTab(props: AvailabilityTabProps) {
  const queryModifier = useCallback(
    (filter: QueryFilterObject) =>
      mergeAll([
        filter,
        {
          articleId: undefined,
          manufacturerNumber: props.manufacturerNumber,
          manufacturer: props.manufacturerId,
          catalogNumber: undefined,
        },
      ]),
    [props.manufacturerNumber, props.manufacturerId]
  );

  return (
    <VStack spacing={0}>
      <Box height={50}>
        <DmsDataGrid
          gridCode="warehouse-availability"
          queryModifier={queryModifier}
          data-testid={suffixTestId('availability-dg', props)}
        />
      </Box>
      <HStack justify="flex-start">
        <Button
          variant="link"
          title={i18n.t('general.actions.refresh')}
          leftIcon="navigation/refresh"
          onClick={() => refreshDmsDatagrid('warehouse-availability')}
          data-testid={suffixTestId('requestsAction.refresh', props)}
        />
      </HStack>
    </VStack>
  );
}
